<i18n>
{
	"en": {
		"all": "All",
		"not": "None"
	},
	"no": {
		"all": "Alle",
		"not": "Ikke"
	}
}
</i18n>
<template>
	<div class="display">
		<div class="display-label">
			<template v-if="itemIsObject">
				{{item[displayKey]}}
			</template>
			<template v-else>
				{{item}}
			</template>
		</div>
		<div>
			<strong v-if="item.op === 'AND'">{{ $t('all') }}</strong>
			<strong v-if="item.op === 'NOT'">{{ $t('not') }}</strong>
		</div>
	</div>
</template>

<script>
export default {
	name: 'TLocationTagInner',
	props: {
		item: Object,
		displayKey: String
	},
	computed: {
		itemIsObject() {
			return typeof (this.item) === 'object' && this.item !== null;
		}
	},
};
</script>

<style lang="scss" scoped>
.display {
	display:flex;
	justify-content:space-between;
	padding-right: 5px;
}
.display-label {
	width: 100%;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
}
</style>
